import { Order, OrderedProduct } from "src/shared/types";

export const buildReturnPayload = (order: Order, returnQty: Record<number, number>, totals: any, refundType: string, reverseDiscount: number) => {
  // New interface: products in orderDetails[0].products
  const products: OrderedProduct[] = order.orderDetails?.[0]?.products ?? [];
  const now = new Date();

  return {
    returnProduct: products
      .map((p, i) => ({
        productId: p.productId,
        returnQty: returnQty[i] || 0,
        productName: p.name,
        arabicName: p.arabicName ?? "",
        unitPrice: Number(p.unitPrice),
      }))
      .filter((p) => p.returnQty > 0),
    Refund: {
      subTotal: totals.amount,
      discount: reverseDiscount,
      refundType,
      refundAmount: totals.refund,
      adjustedAmount: totals.adjusted,
      returnDate: now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0"),
      returnTime: new Date().toTimeString().split(" ")[0].slice(0, 8),
    },
  };
};
